import React, { ReactElement } from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { CodeSplittedDiagram } from '../Views/Diagram/LazyLoad';
import { ConnectedConfigurationContainer } from './configuration/container';

export enum EditTopologyRoutes {
  Configuration = '/configuration',
  Diagram = '/diagram',
}

export function EditTopologyRouter(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${match.path}${EditTopologyRoutes.Configuration}`}
        component={ConnectedConfigurationContainer}
      />
      <Route
        path={`${match.path}${EditTopologyRoutes.Diagram}`}
        component={CodeSplittedDiagram}
      />
      <Redirect to={`${match.path}${EditTopologyRoutes.Configuration}`} />
    </Switch>
  );
}
